<template>
  <div>
    <AppTooltip :disabled="!iconOnly" location="right">
      <template #activator="{ props }">
        <v-list-item
          :class="listItemClasses"
          :color="colorTheme"
          :value="value"
          :to="to ? { name: to } : null"
          v-bind="props"
          @click="onMenuItemClick"
        >
          <div class="d-flex align-center column-gap-2" :class="[textColorClass, { 'justify-center': iconOnly }]">
            <slot name="content">
              <app-icon-ds
                v-if="icon"
                :icon="icon"
                :weight="iconWeight"
                :class="textColorClass"
                size="sm"
              />
              <template v-if="iconComponent">
                <component :is="iconComponent" />
              </template>
              <span v-if="!iconOnly">{{ title }}</span>
            </slot>
          </div>
        </v-list-item>
      </template>
      <span>{{ title }}</span>
    </AppTooltip>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { mapMutations, mapState } from 'vuex'

import AppTooltip from '@/common/AppTooltip.vue'
import { getRoomColorTheme } from '@/common/utils/rooms'
import { ROOMS_ROUTE_NAME } from '@/router'
import { GlobalMutationTypes } from '@/store/modules/global/mutation_types'

export default defineComponent({
  name: 'ProjectNavigationSection',
  components: { AppTooltip },
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    iconComponent: {
      type: String,
      default: null,
    },
    to: {
      type: String,
      default: '',
    },
    value: {
      type: String,
      default: undefined,
    },
    action: {
      type: Function,
      default: null,
    },
  },
  computed: {
    ...mapState('global', ['mini', 'homeLayout', 'projectLayout']),
    ...mapState('room', ['currentRoom']),
    ...mapState('subscription', ['subscriptionBranding']),
    active () {
      if (!this.currentRoom) {
        return false
      }

      return this.$route.name === this.to
    },
    colorTheme () {
      if (this.currentRoom?.subscription?.color &&
        this.currentRoom?.subscription?.customizationEnabled) {
        return this.currentRoom.subscription.color
      } else if (this.subscriptionBranding?.color) {
        return this.subscriptionBranding.color
      }
      return getRoomColorTheme(this.currentRoom)
    },
    iconOnly () {
      return this.mini
    },
    iconWeight () {
      return this.active ? 'fas' : 'far'
    },
    textColorClass () {
      return {
        [`text-${this.colorTheme}`]: this.active,
      }
    },
    listItemClasses () {
      if (this.homeLayout && this.iconOnly) {
        return 'pa-0'
      }
      if (this.projectLayout && this.iconOnly) {
        return 'px-4 py-2 rounded-lg'
      }
      return 'px-3 py-2 rounded-lg'
    },
  },
  methods: {
    ...mapMutations('global', [GlobalMutationTypes.SET_TOGGLE_PROJECT_DRAWER]),

    onMenuItemClick () {
      if (this.$vuetify.display.mobile && this.to === ROOMS_ROUTE_NAME) {
        this.SET_TOGGLE_PROJECT_DRAWER(false)
      }
      if (this.action) {
        this.action()
      }
    },
  },
})
</script>
